import { CategorySizesEnum } from '../enums'

const { SMALL, MEDIUM, LARGE, EXTRA_LARGE, XX_LARGE } = CategorySizesEnum

export const kioskLayouts: CategorySizesEnum[][] = [
  [SMALL, SMALL, EXTRA_LARGE, MEDIUM, SMALL, SMALL, MEDIUM, MEDIUM, MEDIUM],
  [EXTRA_LARGE, MEDIUM, XX_LARGE, MEDIUM, MEDIUM, MEDIUM],
  [EXTRA_LARGE, MEDIUM, MEDIUM, EXTRA_LARGE, EXTRA_LARGE, MEDIUM],
  [SMALL, LARGE, SMALL, SMALL, SMALL, MEDIUM, EXTRA_LARGE, SMALL, SMALL],
  [SMALL, LARGE, SMALL, SMALL, SMALL, MEDIUM, MEDIUM, MEDIUM, SMALL, SMALL],
  [SMALL, LARGE, SMALL, LARGE, SMALL, SMALL, SMALL, LARGE, SMALL],
  [LARGE, LARGE, LARGE, LARGE, LARGE, LARGE],
  [LARGE, SMALL, SMALL, MEDIUM, MEDIUM, MEDIUM, SMALL, LARGE, SMALL],
  [SMALL, LARGE, SMALL, MEDIUM, EXTRA_LARGE, EXTRA_LARGE, MEDIUM],
  [MEDIUM, EXTRA_LARGE, SMALL, LARGE, SMALL, LARGE, SMALL, SMALL],
]
